export default {
  manage_deleteDriverStatus: "Delete Driver Status",
  manage_deleteDriverStatusList: "Delete Driver States",
  manage_deletedDriverStatus: "Driver Status was deleted successfully",
  manage_deletedDriverStatusList: "Driver States were deleted successfully",
  manage_deleteManageDriverStatus_confirmationMessage:
    "Are you sure you want to delete the following Driver States?"
};
